/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BankDtoApiResponse } from '../../models/bank-dto-api-response';
import { CreateCustomerBankCommand } from '../../models/create-customer-bank-command';

export interface CreateBankAsync$Plain$Params {
  id: number;
      body?: CreateCustomerBankCommand
}

export function createBankAsync$Plain(http: HttpClient, rootUrl: string, params: CreateBankAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<BankDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, createBankAsync$Plain.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BankDtoApiResponse>;
    })
  );
}

createBankAsync$Plain.PATH = '/api/customer/{id}/bank';
